import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { LoanType } from "web_myplann/Portfolio/Forms/LoansForm/loanType";
import { CreateLoansForm } from "web_myplann/Portfolio/Pages/LoansCreate/CreateLoansForm";
import { PortfolioAddLayout } from "web_myplann/Portfolio/PortfolioShared/PortfolioAddLayout";

type AddLoansPageProps = {
	loanType: LoanType;
};

export const AddLoansPage = ({ loanType }: AddLoansPageProps) => {
	const { t } = useResource();

	return (
		<PortfolioAddLayout title={t(Resources.Portfolio.AddLoans.Title[loanType])}>
			<CreateLoansForm loanType={loanType} />
		</PortfolioAddLayout>
	);
};
